module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2019_fr-f79b0074df1f4fb8b6830f970bc99ea7.jpg";